import { cn } from "@/lib/utils";

interface DividerProps {
  className?: string;
  size?: "small" | "medium" | "large";
  orientation?: "horizontal" | "vertical";
  borderWidth?: 1 | 2;
}

export const Divider = ({
  className,
  size = "small",
  orientation = "horizontal",
  borderWidth = 2,
}: DividerProps) => (
  <hr
    className={cn(
      orientation === "horizontal"
        ? "border-b border-gray-200 mx-auto"
        : "border-l border-gray-200 my-auto",
      className,
      // Width for horizontal orientation
      orientation === "horizontal" && [
        size === "small" && "w-1/12",
        size === "medium" && "w-1/3",
        size === "large" && "w-full",
      ],
      // Height for vertical orientation
      orientation === "vertical" && [
        size === "small" && "h-4",
        size === "medium" && "h-8",
        size === "large" && "h-16",
      ],
      // Border width
      borderWidth === 1 &&
        (orientation === "horizontal" ? "border-b-0" : "border-l-0"),
      borderWidth === 2 &&
        (orientation === "horizontal" ? "border-b-2" : "border-l-2")
    )}
  />
);
